import { useQuery } from '@tanstack/react-query';

import { fetchFile } from 'apis/hcp/files.api';

const useGetFile = (id: string) => {
  const {
    data: file,
    isPending: fileLoading,
    isError: fileError,
  } = useQuery({
    queryKey: ['file', id],
    queryFn: ({ signal }) => fetchFile(id, signal),
    select: (response) => {
      return response.data.file_url;
    },
    enabled: !!id,
    refetchOnMount: false,
  });
  return { file, fileLoading, fileError };
};

export default useGetFile;
